import { ApiData, getEntitiesPerStoreAsync, Query, ReportResource, Result } from '../Reports';

import {
  ApiCustomerTabCreditAggregate,
  ApiCustomerTabCreditField,
  CustomerTabCreditInfo,
} from './types';

export const mapApiDataToCustomerTabCreditInfo = (apiData: ApiData): CustomerTabCreditInfo => ({
  creditType: String(apiData[ApiCustomerTabCreditField.CreditType]),
  sumCreditAmount: Number(apiData[ApiCustomerTabCreditField.SumCreditAmount]),
  sumCreditCount: Number(apiData[ApiCustomerTabCreditField.SumCreditCount]),
});

export const getCustomerTabCreditsPerStoreAsync = async (
  query: Query,
): Promise<Result<CustomerTabCreditInfo>> =>
  getEntitiesPerStoreAsync<CustomerTabCreditInfo>(
    {
      ...query,
      aggregates: [ApiCustomerTabCreditAggregate.PaymentMethod],
      resource: ReportResource.TillCustomerTabCredit,
    },
    mapApiDataToCustomerTabCreditInfo,
  );
